import { adminClient } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/vue'
import { ac, roles } from '~/utils/permissions'

/**
 * Factory para que TypeScript infiera plugins (admin).
 * `ReturnType<typeof createAuthClient>` pierde `admin` y `user.role`.
 */
function createBetterAuthClient(baseURL: string) {
  return createAuthClient({
    baseURL,
    fetchOptions: {
      credentials: 'include'
    },
    plugins: [
      adminClient({
        ac,
        roles
      })
    ]
  })
}

export type AuthClient = ReturnType<typeof createBetterAuthClient>

/**
 * Cliente Better Auth — crear solo vía useAuthClient().
 *
 * baseURL sale de runtimeConfig.public.apiBaseUrl (NUXT_PUBLIC_API_BASE_URL).
 */
let _authClient: AuthClient | null = null

export function useAuthClient(): AuthClient {
  if (!_authClient) {
    const config = useRuntimeConfig()
    const baseURL = String(config.public.apiBaseUrl || 'http://localhost:3001').replace(/\/$/, '')
    _authClient = createBetterAuthClient(baseURL)
  }

  return _authClient
}
